module.exports = __webpack_public_path__ + "static/media/proj8_img5.b70af304.jpg";